export default __webpack_public_path__ + "static/media/logo-node.f3be0020.svg";